export interface User {
    id: number
    userName: string
}

export namespace User {
  export function sanitize(u: User): User {
    return {
        id: +u.id,
        userName: u.userName,
    }
  }

  export function sanitizeAll(us: User[]): User[] {
    return us.map(u => sanitize(u));
  }
}